<script>
import Correct from '@/assets/images/visualize-items/correct.png'
import CorrectLarge from '@/assets/images/visualize-items/correct-large.png'
import InCorrect from '@/assets/images/visualize-items/incorrect.png'
import TimesUp from '@/assets/images/visualize-items/times-up.png'
import Sunburst from '@/assets/images/visualize-items/sunburst.svg'

const BonusTierImages = [
  Correct,
  CorrectLarge,
  InCorrect,
  TimesUp,
  Sunburst,
]

export default {
  mounted() {
    // Preload the image using the `rel="preload"` attribute.
    BonusTierImages.forEach((imgUrl) => {
      const preloadLink = document.createElement('link')
      preloadLink.rel = 'preload'
      preloadLink.href = imgUrl
      preloadLink.as = 'image'
      document.head.appendChild(preloadLink)
    })
  },
}
</script>
